// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px) {
    .NumerologyCalculator_resp_num__DzzJL{
      padding: 100px 30px !important;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Pages/NumerologyCalculator/NumerologyCalculator.module.css"],"names":[],"mappings":"AAAA;IACI;MACE,8BAA8B;IAChC;EACF","sourcesContent":["@media (max-width: 768px) {\n    .resp_num{\n      padding: 100px 30px !important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resp_num": `NumerologyCalculator_resp_num__DzzJL`
};
export default ___CSS_LOADER_EXPORT___;
